import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DialogComponent, IDialogConfig, TokenStorageService } from '@affinite/common';
import { InboundDocument } from "@affinite/common";
import { LookupService } from '../../services/lookup.service';
import { LookupValue } from '@affinite/common';
import { FaxQueueItem } from '../../models/fax/faxQueueItem';
import { ConfigService } from '../../services/config-service.service';
import { Queue } from '../../models/configuration/queue';
import { DATE_WITH_SECONDS_AMPM, FaxQueue, MYQUEUEFAXES, TEAMQUEUEFAXES } from '../../../assets/constants';
import { MatDialog } from '@angular/material/dialog';
import { FilterService } from '../../services/filter-service.service';
import { Subscription } from 'rxjs';
import { DocumentService } from '@affinite/common';
import { AppSettings } from '../../shared/appsettings';
import { FormService } from '../../services/form-service.service';
import { SignalrService } from '../../services/signalr.service';
import { AutoUnsubscribe } from '../../shared/decorators/auto-unsubscribe.decorator';
import { User } from '../../models/user';
import Swal from 'sweetalert2';
import { FaxHelperService } from '../../services/fax-helper.service';

@Component({
  template: '',
  standalone: false
})
@AutoUnsubscribe
export class FaxQueueComponent implements OnInit, OnDestroy {
  @ViewChild('filterFaxDialogTemplate') filterFaxTemplate: TemplateRef<any> | undefined;
  dateRangeFaxTeamQueue: UntypedFormGroup;
  faxes!: InboundDocument[];
  subs!: Subscription;
  healthPlanEmployeeAuths: boolean = false;
  splittingFax = false;
  lookupData!: LookupValue[];
  statusColor = '';
  faxesCount = 0;
  unfilteredFaxes!: InboundDocument[];
  queues!: FaxQueueItem[];
  selectedFax: string[] = [];
  faxQueues!: Queue[];
  queueSub!: Subscription;
  queueCounts!: { [queueId: string]: number; }
  dateFormat = DATE_WITH_SECONDS_AMPM;
  userFaxQueues!: Queue[];
  filterBadgeData = { text: '', count: 0 }
  faxLocked = false;
  isDisplayContextMenu: boolean = true;
  userConfig: any;
  users: User[] = [];
  receivedDateRange: Date[] = [];
  refreshTitleText = 'Refresh fax queue';
  faxView: FaxQueue = FaxQueue.TEAM_FAXES;

  constructor(private dialog: MatDialog,
    private documentService: DocumentService,
    private lookupService: LookupService,
    private configService: ConfigService,
    private filterService: FilterService,
    private appSettings: AppSettings,
    private tokenStorage: TokenStorageService,
    private signalR: SignalrService,
    private formService: FormService,
    private faxHelper: FaxHelperService) {

    this.dateRangeFaxTeamQueue = new UntypedFormGroup({
      faxStartDate: new UntypedFormControl(),
      faxEndDate: new UntypedFormControl(),
      faxQueue: new UntypedFormControl(),
    });
    this.userConfig = this.tokenStorage.getUserConfig();
  }

  ngOnInit(): void {
    this.queueSub = this.configService.userFaxQueues.subscribe(q => {
      if (q) {
        this.userFaxQueues = q;
      }
    })
    this.queueSub.add(this.configService.faxQueues.subscribe(q => {
      if (q) {
        this.faxQueues = q;
      }
    }))

    this.subs = this.documentService.faxList.subscribe(f => {
      if (f && f.length > 0) {
        if (this.faxView == FaxQueue.MY_FAXES) {
          this.faxes = f.filter(f => f.assignedToUser == this.userConfig.userName);
        } else {
          this.faxes = f.filter(f => !f.assignedToUser);
          if (this.userFaxQueues) {
            const userQueues = this.userFaxQueues.map(u => u.queueId);
            this.faxes = this.faxes.filter(({ assignedToQueueId }) => (userQueues.includes(assignedToQueueId ?? 0) || !assignedToQueueId));
          }
        }

        this.unfilteredFaxes = [...this.faxes];

        if (this.lookupData) {
          this.applyFilter();
          this.populateFaxes();
        }
      }
    })

    this.subs.add(this.configService.userList.subscribe(users => {
      if (users && users.length > 0) {
        this.users = users;
      }
    }))
    this.subs.add(this.lookupService.LookupData.subscribe(l => {
      if (l && l.length > 0) {
        this.lookupData = l;
        this.populateFaxes();
      }
    }))

    this.subs.add(this.filterService.badgeDataBs.subscribe(bd => {
      if (bd.filter_type == TEAMQUEUEFAXES || bd.filter_type == MYQUEUEFAXES) {
        this.filterBadgeData = bd;
      }
    }));

    this.subs.add(this.documentService.DocClosed.subscribe(r => {
      if (r && r == true) {
        this.documentService.getFaxList(this.appSettings.storageServiceBaseUrl);
      }
    }));

    this.subs.add(this.documentService.faxStatusUpdated.subscribe(s => {
      if (s) {
        this.selectedFax = [];
        this.documentService.getFaxList(this.appSettings.storageServiceBaseUrl);
      }
    }))

    this.subs.add(this.formService.faxUnlocked.subscribe(u => {
      if (u) {
        this.selectedFax = [];
        this.documentService.getFaxList(this.appSettings.storageServiceBaseUrl);
      }
    }))

    this.signalR.lockedFaxId.subscribe(id => {
      if (id && this.queues) {
        this.queues.map(item => {
          if (item.internalId == id.faxId) {
            item.locked = true;
            item.lockedByUserName = this.getLockUserName(id.displayName);
            item.lockedBy = id.displayName;
            item.lockDate = id.lockDate;
          }
          if (item.split) {
            item.split.map(sp => {
              if (sp.internalId == id.faxId) {
                sp.locked = true;
                sp.lockedByUserName = this.getLockUserName(id.displayName);
                sp.lockedBy = id.displayName;
                sp.lockDate = id.lockDate;
              }
            })
          }
        })
      }
    })

    this.signalR.unlockedFaxId.subscribe(id => {
      if (id && this.queues) {
        this.queues.map(item => {
          if (item.internalId == id) {
            item.locked = false;
            item.lockedBy = '';
            item.lockedByUserName = '';
            item.lockDate = '';
          }
          if (item.split) {
            item.split.map(sub => {
              if (sub.internalId == id) {
                sub.locked = false;
                sub.lockedBy = '';
                sub.lockedByUserName = '';
                item.lockDate = '';
              }
            })
          }
        })
      }
    })
  }

  getLockUserName(displayName: string) {
    if (this.users) {
      var user = this.users.find(u => u.firstName + ' ' + u.lastName == displayName);
      if (user) {
        return user.userName;
      }
    }
    return displayName;
  }

  ngOnDestroy() {
    this.subs?.unsubscribe();
  }

  populateFaxes() {
    this.queues = this.faxHelper.populateFaxQueue(this.faxes);
    if (this.faxView == FaxQueue.TEAM_FAXES) {
      this.queues.forEach(q => {
        var queueName = this.faxQueues.find(fq => fq.queueId == +q.assignedToQueueId)?.queueName;
        q.queueName = queueName ? queueName.replace(/\(.*?\)/g, "") : 'Unassigned';
        if (q.split && q.split.length > 0) {
          q.split.forEach(s => {
            var sqName = this.faxQueues.find(fq => fq.queueId == +s.assignedToQueueId)?.queueName;
            s.queueName = sqName ? sqName.replace(/\(.*?\)/g, "") : 'Unassigned';
          })
        }
      })
    }
    if (this.selectedFax && this.selectedFax.length > 0) {
      this.queues.forEach(q => {
        if (q.isParent && this.selectedFax.includes(q.internalId)) {
          q.isSelected = true;
          if (q.split && q.split.length > 0) {
            q.split.forEach(s => {
              if (this.selectedFax.includes(s.internalId)) {
                s.isSelected = true;
              }
            })
          }
        } else if (!q.isParent && this.selectedFax.includes(q.internalId)) {
          q.isSelected = true;
        }
      })
    }
    this.faxesCount = this.queues.length;
    this.faxQueues = this.faxHelper.populateFaxQueueCounts(this.faxQueues);
  }

  refreshQueue() {
    this.documentService.getFaxList(this.appSettings.storageServiceBaseUrl);
  }

  removeFaxEvent(event: any) {
    if (event && event.action == 'add') {
      this.updateSelectedFaxes(event.pdfId, 'add');
      if (event.fax.isParent && this.faxView == FaxQueue.TEAM_FAXES) {
        event.fax.split.forEach((child: { internalId: string; }) => {
          if (!this.selectedFax.includes(child.internalId)) {
            this.updateSelectedFaxes(child.internalId, 'add');
          }
        })
      }
    } else if (event && event.action == 'remove') {
      this.updateSelectedFaxes(event.pdfId, 'remove');
      if (event.fax.isParent && event.fax.internalId == event.pdfId && this.faxView == FaxQueue.TEAM_FAXES) {
        event.fax.split.forEach((child: { internalId: any; }) => {
          this.updateSelectedFaxes(child.internalId, 'remove');
        })
      }
    }
  }

  updateSelectedFaxes(pdfId: any, action: string) {
    var index = this.selectedFax.indexOf(pdfId)
    if (index > -1 && action == 'add') { //Already exists
      //Do nothing as the pdf is already in the collection.
      return;
    } else if (index == -1 && action == 'add') {
      this.selectedFax.push(pdfId);
    } else if (index > -1 && action == 'remove') {
      this.selectedFax.splice(index, 1);
    } else if (index == -1 && action == 'remove') {
      //Do nothing as the pdf is not in the collection.
      return;
    }
  }
  /**
   * @brief Updated method to use the Storage service from Common project.
   *  Added new reference to TokenStorageService also so we can get the user name.
   */
  removeCompletedFax() {
    Swal.fire({
      title: 'Delete Permanently',
      text: `Are you sure you want to permanently delete this fax?`,
      icon: 'warning', //possible values - error/success/info/question
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: '#5890a3',
      cancelButtonColor: '#d22329',
      confirmButtonText: 'Delete'
    }).then((result) => {
      if (result.value) {
        let valueId = this.lookupData.find(l => l.lookupStandardValue.toLowerCase() == 'processed' && l.lookupSetID == 145)?.lookupValueID

        if (this.selectedFax.length > 0) {
          this.selectedFax.forEach(async s => {
            if (!valueId) {
              valueId = 10327; //Default Processed value
            }
            var user = this.tokenStorage.getUser();
            //No need to update P8 as this is just a removal from view.
            this.documentService.updateFaxStatus(s, valueId, -1, null, '', 0, false, this.appSettings.storageServiceBaseUrl, user.profile.preferred_username, true);
          })
        }
        this.selectedFax = [];
      }
    });
  }

  referDialogEvent(event: any) {
    let queueId: number = 0;
    let owner: string = '';
    if (isNaN(Number(event.event))) {
      owner = event.event;
    } else {
      queueId = +event.event;
    }
    var user = this.tokenStorage.getUser();
    this.selectedFax.forEach(s => {
      this.documentService.referFax(s,
        queueId,
        owner,
        user.profile.preferred_username,
        this.appSettings.storageServiceBaseUrl)
    })
    this.refreshQueue();
  }

  openFilterDialog() {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '30em',
      data: <IDialogConfig>{
        title: 'Filter Faxes',
        dialogContent: this.filterFaxTemplate,
        acceptButtonTitle1: 'Apply',
        declineButtonTitle: 'Clear Filters'
      }
    });

    var group = this.filterService.getSessionFilter(TEAMQUEUEFAXES);
    if (this.faxView == FaxQueue.MY_FAXES) {
      group = this.filterService.getSessionFilter(MYQUEUEFAXES);
    }
    this.dateRangeFaxTeamQueue = this.filterService.getSavedGroup(group, this.dateRangeFaxTeamQueue);

    //If Fax Received Date range filter is stored in storage then retrieve that and apply that to tfqReceivedDateRange variable.
    //Set tfqReceivedDateRange only if both start and end date were stored
    if (this.dateRangeFaxTeamQueue.controls['faxStartDate'].value && this.dateRangeFaxTeamQueue.controls['faxEndDate'].value) {
      this.receivedDateRange.push(new Date(this.dateRangeFaxTeamQueue.controls['faxStartDate'].value));
      this.receivedDateRange.push(new Date(this.dateRangeFaxTeamQueue.controls['faxEndDate'].value));
    }
    else {
      this.receivedDateRange = [];
    }

    dialogRef.componentInstance.clickAcceptButton1.subscribe(r => {
      this.filterService.saveAsSessionFilter(this.dateRangeFaxTeamQueue, TEAMQUEUEFAXES);
      this.applyFilter();
      this.refreshQueue();
      dialogRef.close();
    })

    dialogRef.componentInstance.clickDeclineButton.subscribe(r => {
      this.faxes = this.unfilteredFaxes;
      this.filterBadgeData = { text: '', count: 0 };
      this.dateRangeFaxTeamQueue.reset();
      this.filterService.resetSessionFilter(TEAMQUEUEFAXES);
      this.receivedDateRange = [];
      this.populateFaxes();
      dialogRef.close();
    })

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
    });
  }

  applyFilter() {
    let group = null;
    if (this.faxView == FaxQueue.MY_FAXES) {
      group = this.filterService.getSessionFilter(MYQUEUEFAXES);
    } else {
      group = this.filterService.getSessionFilter(TEAMQUEUEFAXES);
    }
    if (group && this.lookupData) {
      this.dateRangeFaxTeamQueue = this.filterService.getSavedGroup(group, this.dateRangeFaxTeamQueue);
      const startDate = this.dateRangeFaxTeamQueue.get('faxStartDate')?.value;
      const endDate = this.dateRangeFaxTeamQueue.get('faxEndDate')?.value;
      const filterQueue = this.dateRangeFaxTeamQueue.controls['faxQueue'].value;
      let filterCount = 0;
      if (startDate && endDate) {
        //#26974 - Removing the logic that was filtering out child faxes if the parent fax did not fall within the date range.
        //We just need to filter the faxes based on the date range.
        //If we do want to bring back the parent-child logic then we need to add a checkbox to the filter dialog to allow user to select that option.
        //That way we are not making assumptions on what the user wants.
        this.faxes = this.unfilteredFaxes.filter(f => new Date(f.createdDate) >= new Date(startDate) && new Date(f.createdDate) <= new Date(endDate));
        filterCount++;
      }
      if (filterQueue && startDate && endDate) {
        const parents = this.faxes.filter(f => f.assignedToQueueId == filterQueue.toString() && f.internalDocumentId == f.parentDocumentId);
        const filtered = this.faxes.filter(a => parents.some(b => b.internalDocumentId === a.parentDocumentId) && a.internalDocumentId !== a.parentDocumentId);
        this.faxes = [...parents, ...filtered];
        filterCount++;
      } else if (filterQueue) {
        this.faxes = this.unfilteredFaxes.filter(f => f.assignedToQueueId == filterQueue.toString());
        filterCount++;
      }
      this.populateFaxes();
      if (this.faxView == FaxQueue.MY_FAXES) {
        this.filterService.setBadgeData(group, MYQUEUEFAXES);
      } else {
        this.filterService.setBadgeData(group, TEAMQUEUEFAXES);
      }
    }
  }

  dateRangeChanged(value: any, rangeName: string) {
    if (value && value.length > 0) {
      switch (rangeName) {
        case 'tfqReceivedDates':
        case 'mfqReceivedDates':
          this.dateRangeFaxTeamQueue.controls['faxStartDate'].setValue(value[0]);
          this.dateRangeFaxTeamQueue.controls['faxEndDate'].setValue(value[1]);
          break;
      }
    }
    else {
      this.dateRangeFaxTeamQueue.controls['faxStartDate'].reset();
      this.dateRangeFaxTeamQueue.controls['faxEndDate'].reset();
    }
  }

  unlockFax(item: FaxQueueItem) {
    if (item) {
      this.formService.unlockFax(item.internalId);
      this.signalR.broadcastMessage(`unlocked:${item.internalId}`);
      this.signalR.clientMessage(`Fax ${item.name} has been unlocked by Supervisor`, item.lockedByUserName);
    }
  }
}